<template>
  <el-dialog
    :title="dataForm.id ? '修改' : '新增'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
      <el-form-item label="班级名称" prop="groupName">
        <el-input v-model="dataForm.groupName" placeholder="班级名称"></el-input>
      </el-form-item>
      <el-form-item label="学段" prop="groupStage">
        <el-dict-select
                placeholder="学段"
                v-model="dataForm.groupStage"
                type="openDict"
                :props="{label: 'value', value: 'code'}"
                :params="groupStageParams"
        ></el-dict-select>
      </el-form-item>
      <el-form-item label="排课时间" required>
        <div style="display: flex;">
          <el-form-item prop="startTime">
            <el-time-select
              placeholder="起始时间"
              v-model="dataForm.startTime"
              :picker-options="{
                start: '08:50',
                step: '00:05',
                end: '21:30'
              }">
            </el-time-select>
          </el-form-item>
          <span style="margin: 0 5px;"> - </span>
          <el-form-item prop="endTime">
            <el-time-select
              placeholder="结束时间"
              v-model="dataForm.endTime"
              :picker-options="{
                start: '08:50',
                step: '00:05',
                end: '21:30',
                minTime: dataForm.startTime
              }">
            </el-time-select>
          </el-form-item>
        </div>
      </el-form-item>
      <el-form-item label="班主任" prop="userId">
        <el-dict-select placeholder="班主任" v-model="dataForm.userId" type="teacherSelects" :props="{label: 'realName', value: 'userId'}"></el-dict-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          groupName: '',
          groupStage: '',
          startTime: '',
          endTime: '',
          userId: undefined
        },
        loading: false,
        dataRule: {
          groupName: [
            {required: true, message: '请输入班级名称', trigger: 'blur'}
          ],
          groupStage: [
            {required: true, message: '请选择学段', trigger: 'change'}
          ],
          startTime: [
            {required: true, message: '请选择开始时间', trigger: 'change'}
          ],
          endTime: [
            {required: true, message: '请选择结束时间', trigger: 'change'}
          ]
        }
      }
    },
    computed: {
      groupStageParams() {
        return { type: 'StudentStage' }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`course/studentGroup/info/${this.dataForm.id}`),
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.groupName = data.studentGroup.groupName
                this.dataForm.groupStage = data.studentGroup.groupStage
                this.dataForm.userId = data.studentGroup.userId
                this.dataForm.startTime = data.studentGroup.startTime
                this.dataForm.endTime = data.studentGroup.endTime
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            this.$http({
              url: this.$http.adornUrl(`course/studentGroup/${!this.dataForm.id ? 'save' : 'update'}`),
              method: `${this.dataForm.id ? 'put' : 'post'}`,
              data: this.$http.adornData(this.dataForm)
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: this.dataForm.id ? '更新成功' : '新增成功',
                  type: 'success'
                })
                this.visible = false
                this.$emit('refreshDataList')
              } else {
                this.$message.error(data.msg)
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      },
      getRolesByOrgId (orgId) {
        this.$http({
          url: this.$http.adornUrl('/sys/role/select'),
          method: 'get',
          params: this.$http.adornParams({
            orgId: orgId
          })
        }).then(({data}) => {
          this.roleList = data && data.code === 0 ? data.list : []
        })
      }

    }
  }
</script>
